import traits from './traits';
import components from './components';

export default (editor, config) => {
  components(editor, config);
  traits(editor, config);
};
